module.exports = __webpack_public_path__ + "img/6.87cb12fb.png";